module.exports = __webpack_public_path__ + "components/flag/static/square/nf-11a87569a6918251bd8705450e9e24e8.svg";